import React, { Component } from "react";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { Redirect } from 'react-router-dom';
import { InsertDriveFileOutlined } from '@material-ui/icons';
import { Typography, Badge, Paper, Box } from "@material-ui/core";
import { BLUE_COLOR, LIGHTGRAY_COLOR, MODIFIEDBLACK, RED_COLOR } from "../constants";
import NotificationsIcon from "@material-ui/icons/Notifications";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import ReactSession from '../reactclient.js';
import navigationbanner from '../gallery/navigationbanner.jpg'
import mcblogo from '../gallery/mcblogo.jpg';
import { blue, blueGrey } from "@material-ui/core/colors";
import axios from "axios"
import { fnPostapiResponse, fnGETapiResponse,IFRS17FilesUploadUsers,RbmClientusers, ABDUsers, BatchUploadUsers, CRMUsers, ExpireCDDUsers, DebtorUsers, MaturityUsers, ViewPolicyPendingUsers,Fnencryption } from '../APICall';
import { IdleTimeOutModal } from './Logoutmodal';
import IdleTimer from 'react-idle-timer';


const drawerWidth = 300;

export default class Navigationmenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            timeout: 1000 * 15 * 60,
            showModal: false,
            userLoggedIn: false,
            isTimedOut: false
        }

        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
    }

    _onAction(e) {
        //   console.log("user did something", e)
        this.setState({ isTimedOut: false })
    }

    _onActive(e) {
        console.log('user is active')
        this.setState({ isTimedOut: false })
    }

    _onIdle(e) {
        console.log("user is idle");
        const isTimedOut = this.state.isTimedOut
        if (isTimedOut) {
            this.setState({
                showModal: false,
                redirect: true,
                direction: '/'
            })
        } else {
            this.setState({ showModal: true })
            this.idleTimer.reset();
            this.setState({ isTimedOut: true })
        }

    }

    handleClose() {
        this.setState({ showModal: false })
    }

    handleLogout() {
        this.setState({
            showModal: false,
            redirect: true,
            direction: '/'
        })
    }

    state = {
        open: false, redirect: false, displayNavigation: "displayhidenavigation", direction: "SearchPage", UserName
            : "", amlcheckingtest: "", Istest: false, DBProvider: "", Datasource: "", handleDrawerCloseclass: "",
        displaybatchMenu: "block", displayexpireMenu: "block", displayCRPMENU: "block", displayABDMENU: "block", displayDebtorMENU: "block",
         displayMaturityUserMENU: 'block',displayViewPendingMenu:'block',displayIFRS17FilesUploadUsers:'block',displayRbmClientusers:"block"
    };

    handleDrawerOpen() {
        this.setState({ open: true, handleDrawerCloseclass: "mobile-overlay-active" });
    }

    handleDrawerClose() {
        this.setState({ open: false, handleDrawerCloseclass: "" });
    }
    componentDidMount() {
        this.state.UserName = sessionStorage.getItem('username')
        const queryString = require('query-string');
        var parsed = queryString.parse(window.location.hash)
        // console.log(parsed)
        if (parsed["/AML?DBUserName"] != undefined) {
            // console.log(parsed)
            sessionStorage.setItem('isFromWindowApplication', true)
            sessionStorage.setItem('username', parsed["/AML?DBUserName"])
            sessionStorage.setItem('password', parsed["DBPassword"].replace(' ', '+'))
            sessionStorage.setItem('NIC', parsed["NIC"])
            sessionStorage.setItem('NAME', parsed["NAME"])
            sessionStorage.setItem('FNAME', parsed["FNAME"])
            sessionStorage.setItem('GENDER', parsed["Gender"])
            sessionStorage.setItem('DOB', parsed["DOB"])
            sessionStorage.setItem('ClientNo', parsed["ClientNo"])
            sessionStorage.setItem('Company', parsed["Company"])
            sessionStorage.setItem('ClientType', parsed["ClientType"])
            sessionStorage.setItem('ClientCompanyName', parsed["ClientCompanyName"])
            sessionStorage.setItem('Country', parsed["Country"])
            sessionStorage.setItem('IsWindowsAuth', parsed["IsWindowsAuth"])
            sessionStorage.setItem('IsTest', parsed["Test"])

            if (sessionStorage.getItem('DOB') == "") {
                var date = new Date()
                var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
                var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
                var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1
                sessionStorage.setItem('DOB', CMLSELECTEDATE)
            }

            this.setState({
                redirect: true,
                direction: '/AML',
                displayNavigation: "displayhidenavigation"
            })
        }
        else if (parsed["/CDD?DBUserName"] != undefined) {
            sessionStorage.setItem('isFromWindowApplication', true)
            sessionStorage.setItem('username', parsed["/CDD?DBUserName"])
            // sessionStorage.setItem('password', parsed["DBPassword"].replace(' ','+')) 
            // sessionStorage.setItem('NIC', parsed["NIC"]) 
            sessionStorage.setItem('ClientNo', parsed["ClientNo"])
            sessionStorage.setItem('Company', parsed["Company"])
            sessionStorage.setItem('ClientType', parsed["ClientType"])
            sessionStorage.setItem('Direction', parsed["Direction"])
            this.setState({
                redirect: true,
                direction: '/CDD',
                displayNavigation: "displayhidenavigation"
            })
        }
        else {
            this.setState({ displayNavigation: "displayshownavigation" });
        }
        if (!sessionStorage.getItem('isFromWindowApplication') || sessionStorage.getItem('isFromWindowApplication') == null) {
            var data = {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'GetDbVal',
                "MAPIPORT": '' + process.env.REACT_APP_MPORT + '',
                "body": ''
            }
            fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                if (response.data != undefined) {
                    this.setState({
                        Istest: response.data['Test'],
                        DBProvider: response.data['Provider'],
                        Datasource: response.data['Source'],
                    })
                    sessionStorage.setItem('IsTest', response.data['Test'])
                    if (this.state.Istest)
                        this.setState({ amlcheckingtest: "Test Server" })

                    if (!this.state.Istest)
                        this.setState({ amlcheckingtest: "Live Server" })

                    this.state.UserName = sessionStorage.getItem('username')
                    if (this.state.UserName == "" || this.state.UserName == null) {
                        this.setState({
                            redirect: true,
                            direction: '/'
                        })
                    }
                    else {
                        this.setState({ UserName: sessionStorage.getItem('username') })
                        this.CheckIsadminFlag()
                    }
                }
                else {
                    alert(response.data)
                }
            }).catch(e => console.log(e));
        }
        else {
            if (sessionStorage.getItem("Direction") == 'CDD') {
                this.setState({
                    redirect: true,
                    direction: '/CDD',
                    displayNavigation: "displayhidenavigation"
                })
            }
            else {
                this.setState({
                    redirect: true,
                    direction: '/AML',
                    displayNavigation: "displayhidenavigation"
                })
            }
            //             else{this.setState({ displayNavigation: "displayshownavigation",Istest:process.env.REACT_APP_SOURCE_TEST });
            //             if (process.env.REACT_APP_SOURCE_TEST)
            //                         this.setState({ amlcheckingtest: "Test Server" })
            //                         else
            //                         this.setState({ amlcheckingtest: "Live Server" })
            // }
        }
        // Check User for BatchAccess
        var BatchUsers = BatchUploadUsers()
        var allowBatchUsersAccess = false
        BatchUsers.forEach(element => {
            if (this.state.UserName == element) { allowBatchUsersAccess = true }
        });
        if (allowBatchUsersAccess) {
            this.setState({ displaybatchMenu: '', })
            sessionStorage.setItem("allowBatchUsersAccess", true)
        }
        else {
            this.setState({ displaybatchMenu: 'none' })
            sessionStorage.setItem("allowBatchUsersAccess", false)
        }

        // Check User for ExpireCDD
        var ExpireCDD = ExpireCDDUsers()
        var allowExpireCDDUsersAccess = false
        ExpireCDD.forEach(element => {
            if (this.state.UserName == element) { allowExpireCDDUsersAccess = true }
        });
        if (allowExpireCDDUsersAccess) { this.setState({ displayexpireMenu: '' }) }
        else { this.setState({ displayexpireMenu: 'none' }) }

        // Check User for CRPUsers
        var CRPUsers = CRMUsers()
        var allowCRPUsersAccess = false
        CRPUsers.forEach(element => {
            if (this.state.UserName == element) { allowCRPUsersAccess = true }
        });
        if (allowCRPUsersAccess) { this.setState({ displayCRPMENU: '' }) }
        else { this.setState({ displayCRPMENU: 'none' }) }

        // Check User for ABDUsers
        var ABDUser = ABDUsers()
        var allowABDUsersAccess = false
        ABDUser.forEach(element => {
            if (this.state.UserName == element) { allowABDUsersAccess = true }
        });
        if (allowABDUsersAccess) { this.setState({ displayABDMENU: '' }) }
        else { this.setState({ displayABDMENU: 'none' }) }

        // Check User for Debtor/SalescreenUsers
        var DebtorUser = DebtorUsers()
        var allowDebtorUsersAccess = false
        DebtorUser.forEach(element => {
            if (this.state.UserName == element) { allowDebtorUsersAccess = true }
        });
        if (allowDebtorUsersAccess) { this.setState({ displayDebtorMENU: '' }) }
        else { this.setState({ displayDebtorMENU: 'none' }) }

        // Check User for MAturity
        var MaturityUser = MaturityUsers()
        var allowMaturityUsersAccess = false
        MaturityUser.forEach(element => {
            if (this.state.UserName == element) { allowMaturityUsersAccess = true }
        });
        if (allowMaturityUsersAccess) { this.setState({ displayMaturityUserMENU: '' }) }
        else { this.setState({ displayMaturityUserMENU: 'none' }) }

        // Check User for ViewPendingUsers
        var PolicyPendingUsers = ViewPolicyPendingUsers()
        var allowPolicyPendingUsersAccess = false
        PolicyPendingUsers.forEach(element => {
            if (this.state.UserName == element) { allowPolicyPendingUsersAccess = true }
        });
        if (allowPolicyPendingUsersAccess) { this.setState({ displayViewPendingMenu: '' }) }
        else { this.setState({ displayViewPendingMenu: 'none' }) }

         // Check User for IFRS17FilesUploadUsers
         var IFRS17FilesUsers = IFRS17FilesUploadUsers()
         var allowIFRS17FilesAccess = false
         IFRS17FilesUsers.forEach(element => {
             if (this.state.UserName == element) { allowIFRS17FilesAccess = true }
         });
         if (allowIFRS17FilesAccess) { this.setState({ displayIFRS17FilesUploadUsers: '' }) }
         else { this.setState({ displayIFRS17FilesUploadUsers: 'none' }) } 


          // Check User for RbmClientusers
          var Rbmcleintuser = RbmClientusers()
          var allowRbmcleintuserAccess = false
          Rbmcleintuser.forEach(element => {
              if (this.state.UserName == element) { allowRbmcleintuserAccess = true }
          });
          if (allowRbmcleintuserAccess) { this.setState({ displayRbmClientusers: '' }) }
          else { this.setState({ displayRbmClientusers: 'none' }) } 

    }

    CheckIsadminFlag() {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'IsAdminFlag',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
            "body": {

                "DBUserName": "" + this.state.UserName + "",
                "DBPassword": "" + Fnencryption(sessionStorage.getItem('password') )+ "",
                "DBSource": "" + this.state.Datasource + "",
                "DBProvider": "" + this.state.DBProvider + "",
                "Test": this.state.Istest
            }
        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare1', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            sessionStorage.setItem('isadminFlag', response.data)
        })//.catch(e => console.log(e));
        .catch((error) => {console.log(error.response.statusText)})
    }

    handleOnClick = () => {
        var r = window.confirm("Do you want to logout?")
        if (r == true) {
            this.setState({
                redirect: true,
                direction: '/'
            })
        }
    }



    render() {
        const { open } = this.state;
        var dashboardColor = MODIFIEDBLACK;
        var policiesColor = MODIFIEDBLACK;
        var BatchColor = MODIFIEDBLACK;
        var cmscolor = MODIFIEDBLACK;
        var cmlcolor = MODIFIEDBLACK;
        var mvpColor = MODIFIEDBLACK;
        var EXPRIRECOLOR = MODIFIEDBLACK;
        var CRPCOLOR = MODIFIEDBLACK;
        if (this.props.selectedMenu === 'AMLSEARCH') {
            dashboardColor = BLUE_COLOR;
            policiesColor = MODIFIEDBLACK;
            BatchColor = MODIFIEDBLACK;
            cmscolor = MODIFIEDBLACK
            cmlcolor = MODIFIEDBLACK;
            mvpColor = MODIFIEDBLACK;
            EXPRIRECOLOR = MODIFIEDBLACK;
            CRPCOLOR = MODIFIEDBLACK;
        }
        if (this.props.selectedMenu === 'CDDCRM') {
            dashboardColor = MODIFIEDBLACK;
            policiesColor = BLUE_COLOR;
            mvpColor = MODIFIEDBLACK;
            cmscolor = MODIFIEDBLACK;
            BatchColor = MODIFIEDBLACK;
            cmlcolor = MODIFIEDBLACK;
            EXPRIRECOLOR = MODIFIEDBLACK;
            CRPCOLOR = MODIFIEDBLACK;
        }
        if (this.props.selectedMenu === 'BATCHPAGE') {
            dashboardColor = MODIFIEDBLACK;
            BatchColor = BLUE_COLOR;
            policiesColor = MODIFIEDBLACK;
            mvpColor = MODIFIEDBLACK;
            cmscolor = MODIFIEDBLACK;
            cmlcolor = MODIFIEDBLACK;
            EXPRIRECOLOR = MODIFIEDBLACK;
            CRPCOLOR = MODIFIEDBLACK;
        }
        if (this.props.selectedMenu === 'EXPIRE') {
            dashboardColor = MODIFIEDBLACK;
            BatchColor = MODIFIEDBLACK;
            policiesColor = MODIFIEDBLACK;
            mvpColor = MODIFIEDBLACK;
            cmscolor = MODIFIEDBLACK;
            cmlcolor = MODIFIEDBLACK;
            EXPRIRECOLOR = BLUE_COLOR;
            CRPCOLOR = MODIFIEDBLACK;
        }
        if (this.props.selectedMenu === 'CRP') {

            CRPCOLOR = BLUE_COLOR;
            dashboardColor = MODIFIEDBLACK;
            BatchColor = MODIFIEDBLACK;
            policiesColor = MODIFIEDBLACK;
            mvpColor = MODIFIEDBLACK;
            cmscolor = MODIFIEDBLACK;
            cmlcolor = MODIFIEDBLACK;
            EXPRIRECOLOR = MODIFIEDBLACK;
        }

        return (

            <div className={this.state.displayNavigation} >
                <CssBaseline />

                {this.state.redirect &&
                    <Redirect to={this.state.direction} />
                }

                <AppBar
                    color="default"
                    position="fixed"
                    style={{
                        width: '100%'
                    }}
                // className={clsx(classes.appBar, {
                //     [classes.appBarShift]: open,
                // })}
                >
                    <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this.onIdle}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={this.state.timeout} />
                    <IdleTimeOutModal
                        showModal={this.state.showModal}
                        handleClose={this.handleClose}
                        handleLogout={this.handleLogout}

                    />

                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => this.handleDrawerOpen()}
                            edge="start"
                        >
                            <MenuIcon />
                        </IconButton>

                        <div style={{ position: 'absolute', right: 2, display: 'flex', paddingTop: 10 }}>

                            <div style={{ width: 300, display: 'flex' }}>
                                <div style={{
                                    backgroundColor: BLUE_COLOR,
                                    borderRadius: 60,
                                    height: 40,
                                    width: 40,
                                    justifyContent: 'center'
                                }}>
                                    <Typography style={{
                                        color: 'white',
                                        fontFamily: 'Globerbold',
                                        fontSize: 18,
                                        textAlign: 'center',
                                        paddingTop: 6
                                    }}>
                                        S
                                    </Typography>
                                </div>
                                <div style={{ display: 'column', marginLeft: 10 }}>
                                    <Typography style={{ color: MODIFIEDBLACK, fontSize: 18, fontFamily: 'Globerbold', marginTop: -2 }}>
                                        {this.state.UserName}</Typography>
                                    <Typography
                                        style={{ color: MODIFIEDBLACK, fontSize: 18, fontFamily: 'Globerregular', marginTop: -5 }}>
                                        SWAN </Typography>

                                </div>
                                <Typography
                                    style={{ color: RED_COLOR, fontSize: 18, fontFamily: 'Globerregular', marginTop: -2, marginLeft: 16 }}>
                                    {this.state.amlcheckingtest} </Typography>
                            </div>
                            <div style={{
                                height: 35,
                                width: 1,
                                backgroundColor: 'rgba(191,193,194,1.0)',
                                marginLeft: 1,
                                marginRight: 1,
                                marginTop: 5
                            }} />

                            <IconButton color="inherit">
                                <LogoutIcon button onClick={() => this.handleOnClick()} style={{ color: BLUE_COLOR, marginTop: -5 }} fontSize={'large'} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>

                <Drawer
                    style={{
                        width: drawerWidth,
                        flexShrink: 0
                    }}
                    anchor="left"
                    open={open}

                >
                    <img src={navigationbanner} style={{ width: 350, height: 275 }} />

                    <Paper style={{
                        height: 100,
                        marginLeft: 350 / 2 - 55,
                        marginTop: -50,
                        width: 100,
                        borderRadius: 60
                    }}>
                        <img src={mcblogo} style={{ width: 96, height: 96, borderRadius: 60 }} />
                    </Paper>

                    <Box display="flex"
                        style={{ marginTop: 15 }}
                        alignItems="center"
                        justifyContent="center">
                        <Typography style={{ fontFamily: 'Globerbold', fontSize: 22 }}>OneSWAN</Typography>
                        {/* <Typography style={{ fontFamily: 'Globerbold',color:blueGrey ,fontSize: 14 }}>  (BETA V.1)</Typography> */}
                    </Box>
                    <List style={{ width: 350, marginTop: 15 }}>
                        <ListItem button onClick={() => this.setState({ redirect: true, direction: 'AML' })}>
                            <ListItemIcon>
                                <DashboardIcon style={{ color: dashboardColor }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: dashboardColor }}>AMl SEARCH</Typography>
                        </ListItem>
                        <div style={{ height: 5 }} />
                        <ListItem button onClick={() => this.setState({ redirect: true, direction: 'CDD' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: policiesColor }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: policiesColor }}> Risk-Based Matrix (RBM)</Typography>
                        </ListItem>
                        <ListItem style={{ display: this.state.displaybatchMenu }} button onClick={() => this.setState({ redirect: true, direction: 'BATCH' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: BatchColor }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: BatchColor }}>Upload Batchids </Typography>
                        </ListItem>
                        <ListItem style={{ display: this.state.displayexpireMenu }} button onClick={() => this.setState({ redirect: true, direction: 'EXPIRE' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: EXPRIRECOLOR }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: EXPRIRECOLOR }}>EXPIRE CDD</Typography>
                        </ListItem>
                        <ListItem style={{ display: this.state.displayCRPMENU }} button onClick={() => this.setState({ redirect: true, direction: 'CRP' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: CRPCOLOR }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: CRPCOLOR }}>Client Risk Profile (CRP)</Typography>
                        </ListItem>
                        <ListItem style={{ display: this.state.displayABDMENU }} button onClick={() => this.setState({ redirect: true, direction: 'ABD' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: cmlcolor }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: cmlcolor }}>Actisure Bank Details</Typography>
                        </ListItem>
                        {/* <ListItem button onClick={() => this.setState({ redirect: true, direction: 'Maintenance' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: cmlcolor }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: cmlcolor }}>Maintenance Compliance</Typography>
                        </ListItem> */}
                        {/* <ListItem style={{ display: this.state.displayRbmClientusers }} button onClick={() => this.setState({ redirect: true, direction: 'ClientList' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: cmlcolor }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: cmlcolor }}>COMPLIANCE LIST (RBM Client)</Typography>
                        </ListItem> */}
                        <ListItem style={{ display: this.state.displayDebtorMENU }} button onClick={() => this.setState({ redirect: true, direction: 'SPS' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: cmlcolor }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: cmlcolor }}>Debtors List</Typography>
                        </ListItem>
                        {/* <ListItem style={{ display: this.state.displayMaturityUserMENU }} button onClick={() => this.setState({ redirect: true, direction: 'MLP' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: cmlcolor }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: cmlcolor }}>Maturities</Typography>
                        </ListItem> */}
                        <ListItem style={{ display: this.state.displayViewPendingMenu }} button onClick={() => this.setState({ redirect: true, direction: 'view_pending_requests' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: cmlcolor }} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: cmlcolor }}>View pending requests</Typography>
                        </ListItem>
                        {/* <ListItem style={{ display: this.state.displayIFRS17FilesUploadUsers }} button onClick={() => this.setState({ redirect: true, direction: 'IFRS' })}>
                            <ListItemIcon>
                                <InsertDriveFileOutlined style={{ color: cmlcolor}} />
                            </ListItemIcon>
                            <Typography style={{ textTransform: 'uppercase', fontFamily: 'Globerbold', color: cmlcolor }}>Upload IFRS17</Typography>
                        </ListItem> */}
                    </List>
                </Drawer>

                <div className={this.state.handleDrawerCloseclass}
                    onClick={() => this.handleDrawerClose()}
                    style={{
                        position: "absolute",
                        zIndex: open ? 9000 : -9000,
                        left: drawerWidth,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "transparent",
                        display: "none",
                    }}
                ></div>
            </div>
        );
    }
}
//export default withStyles(useStyles,{index:1})(Navigationmenu);